// @flow
import * as React from 'react';

export const ErrorAlert = (props: { children: any }) => (
  <div
    className="tc pa2 f6 mb4 br1"
    style={{ color: '#C23030', backgroundColor: '#FFDDDD' }}
  >
    {props.children}
  </div>
);

export const SuccessAlert = (props: { children: any }) => (
  <div
    className="tc pa2 f6 mb4 br1"
    style={{
      backgroundColor: '#d3e3be',
    }}
  >
    {props.children}
  </div>
);

export const Alert = (props: { children: any }) => (
  <div className="tc pa2 f6 mb4 br1 white bg-black-60">{props.children}</div>
);



// WEBPACK FOOTER //
// ./src/components/alerts.js